import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { upload } from "../../store/actions/vendor/Vendor";
import { Table, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  getCategory as getCategoryList,
  addCategory,
} from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";

const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

const AddCategory = (props) => {
  const classes = useStyles();
  const [imageUploadMessage, updateImageUploadMessage] = useState("");
  const [category, updateCategory] = useState({});

  useEffect(() => {
    props.getCategoryList();
    setSuperCategory(props.match.params.superCategoryId);
  }, []);

  const setSuperCategory = (superCategoryId) => {
    updateCategory({ ...category, superCategoryId: superCategoryId });
  };

  const onChange = (event) => {
    let tempCategory = { ...category };
    tempCategory[event.target.name] = event.target.value;
    updateCategory(tempCategory);
  };

  const onUpload = (event) => {
    updateImageUploadMessage("Uploading the file, please wait...");
    const data = new FormData();
    data.append("files", event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage("File uploaded successfully.");
          let tempCategory = { ...category };
          tempCategory.icon = `${response.data.uploads[0].path}`;
          updateCategory(tempCategory);
        } else {
          updateImageUploadMessage("Please, try Again");
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          "An error occurred while executing the query. Please try Again"
        );
      });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    props.addCategory(category).then((data) => {
      if (data) {
        props.history.push(
          `/admin/all-category/${category?.superCategoryId}`
        );
      }
    });
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add a Category</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Category Name"
              value={category?.name}
              onChange={onChange}
              name="name"
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <select
              fullWidth={true}
              required="required"
              name="superCategoryId"
              id="inputState"
              className="form-control"
              value={category?.superCategoryId}
              onChange={onChange}
              style={{ marginTop: "2.5em" }}
            >
              {props?.superCategories?.length > 0 ? (
                props?.superCategories
                  .filter(
                    (categorieFilter) =>
                      categorieFilter.id === category?.superCategoryId
                  )
                  .map((type) => (
                    <option value={type?.id} key={type?.id}>
                      {type?.name}
                    </option>
                  ))
              ) : (
                <option disabled="disabled" selected="selected">
                  Select Super-Category
                </option>
              )}
            </select>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Category Icon"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onUpload}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <br />
          <p style={{ color: "#000" }}>{imageUploadMessage}</p>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: "#fff",
            backgroundColor: "#9c27b0",
            boxShadow:
              "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
          }}
        >
          Add Category
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{category?.name}</td>
            <td>
              <img src={category?.icon} style={{ height: "70px" }} />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  superCategories: state.admin.superCategories,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    addCategory: (categoryData) => dispatch(addCategory(categoryData)),
    upload: (data) => dispatch(upload(data)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AddCategory);
